import React, {Fragment} from "react";
import {DraaiType} from "../../../Model";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageAL from '../../../images/situation/draaitype/AL luik linksdraaiend.jpg';
import imageAR from '../../../images/situation/draaitype/AR luik rechtsdraaiend.jpg';
import imageB from '../../../images/situation/draaitype/B luik dubbel luik.jpg';
import imageCL from '../../../images/situation/draaitype/CL vouwluik linksdraaiend draaipunt binnen.jpg';
import imageCR from '../../../images/situation/draaitype/CR vouwluik rechtsdraaiend draaipunt binnen.jpg';
import imageDL from '../../../images/situation/draaitype/DL vouwluik linksdraaiend draaipunt buiten.jpg';
import imageDR from '../../../images/situation/draaitype/DR vouwluik rechtsdraaiend draaipunt buiten.jpg';
import imageE from '../../../images/situation/draaitype/E vouwluik links en vouwluik rechts draaipunt binnen.jpg';
import imageEL from '../../../images/situation/draaitype/EL vouwluik links draaipunt binnen en enkel luik rechts.jpg';
import imageER from '../../../images/situation/draaitype/ER enkel luik links en vouwluik rechts draaipunt binnen.jpg';
import imageF from '../../../images/situation/draaitype/F vouwluik links en vouwluik rechts draaipunt buiten.jpg';
import imageFL from '../../../images/situation/draaitype/FL vouwluik links draaipunt buiten en enkel luik rechts.jpg';
import imageFR from '../../../images/situation/draaitype/FR enkel luik links en vouwluik rechts draaipunt buiten.jpg';
import imageALO from '../../../images/situation/draaitype/ALO luik linksdraaiend overlappend.jpg';
import imageARO from '../../../images/situation/draaitype/ARO luik rechtsdraaiend overlappend.jpg';
import imageBLO from '../../../images/situation/draaitype/BLO dubbel luik- linkerluikoverlappend.jpg';
import imageBRO from '../../../images/situation/draaitype/BRO dubbel luik- rechterluikoverlappend.jpg';

export default function DraaitypeWindow(props) {
    return <Fragment>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.AL}
                          image={imageAL}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.AR}
                          image={imageAR}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.B}
                          image={imageB}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.CL}
                          image={imageCL}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.CR}
                          image={imageCR}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.DL}
                          image={imageDL}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.DR}
                          image={imageDR}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.E}
                          image={imageE}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.EL}
                          image={imageEL}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.ER}
                          image={imageER}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.F}
                          image={imageF}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.FL}
                          image={imageFL}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.FR}
                          image={imageFR}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.ALO}
                          image={imageALO}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.ARO}
                          image={imageARO}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.BLO}
                          image={imageBLO}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={DraaiType.BRO}
                          image={imageBRO}/>
    </Fragment>
}

DraaitypeWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}